<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="人气温泉" name="1"></el-tab-pane>
            <el-tab-pane label="热门景点" name="2"></el-tab-pane>
            <el-tab-pane label="日本美食" name="3"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-head">
                <div class="f-14 color-grays"></div>
                <el-button type="primary" size="mini" @click="$router.push({path:'/center/addStory'})">添加故事+</el-button>
            </div>
            <div class="list-item" v-for="(item,index) in list" :key="index">
                <img :src="`/api/v1/file/${item.cover}`" alt="" class="list-item-img">
                <div>
                    <div class="mb-10 item-title">
                        <div class="f-16 fw-b ">{{item.title}}</div>
                    </div>
                    <div class="f-14 mb-10">人均消费：
                        <span class="f-16 color-red">{{+item.per_capita|parseMoney}}</span>
                        <span class="f-14 color-grays">  {{item.currency}}</span>
                    </div>
                    <el-tag type="primary" class="mb-10" size="mini">{{item.type}}</el-tag>
                    <div class="f-14 color-grays"><i class="el-icon-location"></i> {{item.address}}</div>
                </div>
                <div class="ml-a">
                    <el-button type="success" size="mini" @click="toDetail(item)">查看详情</el-button>
                    <el-button type="warning" size="mini" @click="toEdit(item)">编辑</el-button>
                    <!--<el-button type="primary" size="mini">删除</el-button>-->
                </div>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myStory",
        data() {
            return {
                activeName: '1',
                loading: false,
                list: []
            }
        },
        created() {
            this.userHotSpring();
        },
        methods: {
            handleClick(tab) {
                if (tab.name === '1') {
                    this.userHotSpring();
                } else if (tab.name === '2') {
                    this.userScenery();
                } else if (tab.name === '3') {
                    this.userCate();
                }
            },
            async userHotSpring() {
                this.loading = true;
                let [e, data] = await this.$api.userHotSpringApi()
                this.loading = false;
                this.list = data.result;
            },
            async userScenery() {
                this.loading = true;
                let [e, data] = await this.$api.userSceneryApi()
                this.loading = false;
                this.list = data.result;
            },
            async userCate() {
                this.loading = true;
                let [e, data] = await this.$api.userCateApi()
                this.loading = false;
                this.list = data.result;
            },
            toDetail({id}) {
                let path = ''
                if (this.activeName === '1') {
                    path = '/hotSpringDetail'
                } else if (this.activeName === '2') {
                    path = '/sceneDetail'
                } else if (this.activeName === '3') {
                    path = '/cateDetail'
                }
                this.$router.push({path, query: {id}})
            },
            toEdit({id}) {
                this.$router.push({path: '/center/addStory', query: {id, type: this.activeName}})
            }

        },
    }
</script>

<style scoped lang="less">
    .list-content {
        width: 100%;

        .list-head {
            width: 100%;
            height: 54px;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        .list-item {
            width: 100%;
            height: 140px;
            padding: 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .list-item-img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-right: 20px;
                border-radius: 8px;
            }

            .item-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .btn-content {
                margin-top: 10px;
            }
        }
    }
</style>
